import styled from 'styled-components';

const OTPInputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
export { OTPInputContainer };
